import React from 'react';
import { ISigningAppointmentDocumentResponse } from '../../../../../../../types/signingAppointment/ISigningAppointmentDocumentResponse';
import { IncomingItem } from './IncomingItem';
import { Show } from '../../../../../../shared/Show';
import { CardTW } from '../../../../../../../tailwindComponents/CardTW/CardTW';
import { ISigningAppointmentScanbackManifest } from '../../../../../../../types/signingAppointment/ISigningAppointmentScanbackManifest';
import { IncomingDocumentsProgress } from './IncomingDocumentsProgress';

export interface IncomingDocumentsTableProps {
  incomingDocs: ISigningAppointmentDocumentResponse[];
  setPreviewDoc: (docUrl: string) => void;
  manifest: ISigningAppointmentScanbackManifest | undefined;
}

export const IncomingDocumentsTable: React.FC<IncomingDocumentsTableProps> = ({
  incomingDocs,
  setPreviewDoc,
  manifest,
}) => (
  <CardTW>
    <section className="pt-4" data-test-id={`incoming-documents-title`}>
      <div className={'flex'}>
        <div className={'w-1/2'}>
          <span className="font-inter text-base font-semibold not-italic leading-6 text-black">Incoming Documents</span>
        </div>
        <div className={'w-1/2 p-1'}>{manifest && <IncomingDocumentsProgress manifest={manifest} />}</div>
      </div>
      <Show when={!!incomingDocs.length} fallback={<div>No incoming documents</div>}>
        <div className="space-y-4">
          {incomingDocs.map((document) => (
            <IncomingItem key={document.id} document={document} setPreviewDoc={setPreviewDoc} />
          ))}
        </div>
      </Show>
    </section>
  </CardTW>
);
